import React, { useEffect } from "react";
import { Box, Grid, Container } from "@mui/material";
import styled from "@emotion/styled";
import MenuService from "../../components/Menu/menuService";
import SignUpCard from "../../components/SignUpForm/SignUpCard";
import Image from "../../img/banner-image-v2.png";

const ImgBox = styled(Box)`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    position: absolute;
    z-index: -1;
    width: 80% !important;
    left: 10%;
    opacity: 0.6;
  }
  @media (max-width: 1024px) {
    width: 45%;
  }
`;

const CardBox = styled(Box)`
  width: 50%;
  display: flex;
  justify-content: right;
  @media (max-width: 768px) {
    width: 100% !important;
  }
  @media (max-width: 1024px) {
    width: 55%;
  }
`;

const SignUp = () => {
  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("sign-up");
  }, []);

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: "flex",
        paddingTop: "80px",
        paddingBottom: "80px",
        position: "relative",
        justifyContent: "center",
        "@media (max-width: 600px)": {
          paddingTop: "40px",
          paddingBottom: "40px",
        },
      }}
    >
      <ImgBox>
        <img className="bannerImge" src={Image} alt={"banner image"} />
      </ImgBox>
      <CardBox>
        <SignUpCard />
      </CardBox>
    </Container>
  );
};

export default SignUp;
